import { useNavigate } from 'react-router-dom';
import {
  Box,
  Dialog,
  Portal,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import SumsubWebSdk from '@sumsub/websdk-react';
import { ReactComponent as Warning } from 'assets/icons/warning.svg';
import { useKycLevel1 } from 'hooks';
import { useTranslation } from 'localization';

import {
  Button,
  SERVICE_CARD_BORDER_RADIUS,
  ServiceDialogBody,
  ServiceDialogCloseTrigger,
  ServiceDialogHeader,
  serviceDialogShellProps,
} from 'components';

const SumSub = () => {
  const { t } = useTranslation('component.dashboard.sumsub');
  const navigate = useNavigate();

  const { mutateAsync: upgradeLevel1, data: kycData } = useKycLevel1();
  const { open, onOpen, onClose } = useDisclosure();

  const onCloseHandler = () => {
    navigate(0);
    onClose();
  };

  return (
    <Box w="100%" bg="lightPrimary">
      <Stack
        justify="space-between"
        w="full"
        px={{ base: '6', lg: '10' }}
        py="7"
        borderRadius={SERVICE_CARD_BORDER_RADIUS}
        direction={{ base: 'column', lg: 'row' }}
        align="center"
      >
        <Stack
          direction={{ base: 'column', lg: 'row' }}
          gap="6"
          align="center"
          mb={{ base: '4', lg: '0' }}
        >
          <Warning />
          <Text color="warning">{t('sumSubUpgradeHint')}</Text>
        </Stack>
        <Button
          variant="filled"
          title="Verify"
          w="167px"
          onClick={() => upgradeLevel1([]).then(() => onOpen())}
        />
      </Stack>
      <Dialog.Root
        closeOnInteractOutside={false}
        open={open}
        size="full"
        scrollBehavior="inside"
        onOpenChange={(e: { open: boolean }) => {
          if (!e.open) {
            onCloseHandler();
          }
        }}
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content {...serviceDialogShellProps({ maxW: 'full' })}>
              <ServiceDialogHeader>{t('upgradeToLvl1')}</ServiceDialogHeader>
              <ServiceDialogCloseTrigger />
              <ServiceDialogBody p={0} px={0} py={0} bg="sumsub">
                {kycData && (
                  <SumsubWebSdk
                    accessToken={kycData.token}
                    expirationHandler={() => onCloseHandler()}
                  />
                )}
              </ServiceDialogBody>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </Box>
  );
};
export default SumSub;
